import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { queryClient } from "@/lib/queryClient";
import { initNative } from "@/lib/native";

initNative();

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Prerender (puppeteer) statik HTML üretirse #root dolu gelir → hydrate et.
// Aksi halde normal client render. (SEO: Google/sosyal botlar hazır HTML görür.)
if (container.hasChildNodes()) {
  // React 19 metadata'yı client'ta yeniden üretir; prerender'dan gelen SEO
  // etiketlerini kaldır ki ÇİFT (2 title/canonical/description) olmasın.
  document
    .querySelectorAll(
      'head > title, head > link[rel="canonical"], head > meta[name="description"], head > meta[name="robots"], head > meta[property="og:title"], head > meta[property="og:description"], head > meta[property="og:url"], head > meta[name="twitter:title"], head > meta[name="twitter:description"]'
    )
    .forEach((el) => el.remove());
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
